import React, { useState, useMemo } from "react";
import useSWR from "swr";
import { secureFetcher, SECURITY_CONFIG } from "../../config/security";

const ComponentEstimateCard = ({ onNext }) => {
  const [selectedCards, setSelectedCards] = useState([]);

  const {
    data: servicesData,
    error: servicesDataError,
    isValidating, // NAYA HOOK: Ye check karega ke API hit ho rahi hai ya nahi
  } = useSWR(
    "https://47.activ8.digital/wp-json/wp/v2/cloudservice?per_page=100&_embed",
    secureFetcher,
  );

  const sortedServicesData = useMemo(() => {
    if (!servicesData) return [];

    return [...servicesData].sort((a, b) => {
      const orderA = a.acf?.price_calculator_order?.service_order ?? 999;
      const orderB = b.acf?.price_calculator_order?.service_order ?? 999;

      return orderA - orderB;
    });
  }, [servicesData]);

  // ERROR STATE
  if (servicesDataError) {
    return (
      <section className="py-5">
        <div className="container-custom text-center text-danger py-5">
          <p>Error loading data. Please try again later.</p>
        </div>
      </section>
    );
  }

  // BULLETPROOF LOADING STATE:
  // Jab tak API se fresh data fetch ho raha hai (isValidating) YA data bilkul nahi hai, Loader show hoga.
  if (isValidating || !servicesData) {
    return (
      <section className="py-5">
        <div
          className="container-custom d-flex justify-content-center align-items-center"
          style={{ minHeight: "400px" }}
        >
          <div className="loader my-3">
            <img src="assets/img/LoaderSky47.gif" alt="loader" />
          </div>
        </div>
      </section>
    );
  }

  const toggleSelection = (cardId) => {
    if (selectedCards.includes(cardId)) {
      setSelectedCards(selectedCards.filter((id) => id !== cardId));
    } else {
      setSelectedCards([...selectedCards, cardId]);
    }
  };

  const handleNextClick = () => {
    const selectedData =
      sortedServicesData.filter((service) =>
        selectedCards.includes(service.id),
      ) || [];
    onNext(selectedData);
  };

  return (
    <section className="py-5">
      <div className="container-custom">
        <div className="estimate-wrapper p-4">
          <h2 className="mb-4 fw-bold py-3">Add To This Estimate</h2>

          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 mb-4">
            {sortedServicesData.map((service) => {
              const isSelected = selectedCards.includes(service.id);

              return (
                <div className="col" key={service.id}>
                  <div
                    className={`card custom-estimate-card h-100 ${isSelected ? "selected" : ""}`}
                    onClick={() => toggleSelection(service.id)}
                  >
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <h5
                          className="card-title fw-bold mb-0 pe-2"
                          dangerouslySetInnerHTML={{
                            __html: service.title?.rendered,
                          }}
                        />

                        <div
                          className={`icon-circle ${isSelected ? "icon-selected" : ""}`}
                        >
                          {isSelected ? (
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="white"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                          ) : (
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="white"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <line x1="12" y1="5" x2="12" y2="19"></line>
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                          )}
                        </div>
                      </div>

                      <div
                        className="card-text text-secondary"
                        style={{ fontSize: "0.85rem" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            service.acf?.price_calculator_order
                              ?.cloud_service_description ||
                            service.content?.rendered ||
                            "",
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="d-flex justify-content-end border-top pt-3 mt-3">
            <button
              className="btn btn-dark px-4 py-2 fw-bold"
              onClick={handleNextClick}
              disabled={selectedCards.length === 0}
            >
              Next Step
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComponentEstimateCard;
